import { lazy } from "react";
import { Navigate, useParams } from "react-router";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";
import { paths } from "./paths";

const ContactsPage = lazy(() => import("../../_features/contacts/pages/ContactsPage"));

// `/customers` was a superseded duplicate of `_features/company` (same
// underlying Company record, an older parallel detail page with two
// non-functional tabs where Company has real ones) - retired, not migrated.
// It was already unreachable from primary nav (a parent nav item with
// dropdown children renders as a non-clickable header, never a link - see
// _layouts/navigation/components/MenuItem.jsx), so these redirects only
// catch direct URLs/bookmarks. See docs/bug-sheet.md.
const CustomerDetailsRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`${paths.company}/${id}`} replace />;
};

export const customerRoutes = [
    { path: "/customers", element: <Navigate to={paths.company} replace /> },
    { path: "/customers/:id", element: <CustomerDetailsRedirect /> },
    {
        path: "/contacts", element:
            <FeatureFlagRoute feature="contacts">
                <PermissionRoute permission={ROUTE_PERMISSIONS.contacts.view} moduleName="Contacts">
                    <ContactsPage />
                </PermissionRoute>
            </FeatureFlagRoute>
    }
];
